module.exports = __webpack_public_path__ + "fa9231c5892462132747d1d198a2d341.png";